import { useCallback } from 'react';

import BannerType from '../../../../../types/banner/BannerType';

const MAX_FULL_IMAGE_WIDTH = 1900;

const useBannerSliderSettings = ({ overrideSettings, autoplaySpeed }) => {
  const hasVideoSlides = useCallback((slides = []) => {
    return slides.some((slide) => {
      return (
        slide.type === BannerType.VIDEO &&
        (!!slide.video_file || !!slide.video_link)
      );
    });
  }, []);

  const shouldUseVariableWidth = useCallback(
    (slides = []) => {
      if (hasVideoSlides(slides)) {
        return true;
      }

      return !slides.every(
        (slide) => slide.image_width >= MAX_FULL_IMAGE_WIDTH
      );
    },
    [hasVideoSlides]
  );

  const getSettings = useCallback(
    (slides = []) => {
      const slideCount = slides.length;

      const effectiveSettings = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: autoplaySpeed,
        centerMode: false,
        draggable: true,
        swipeToSlide: true,
        variableWidth: shouldUseVariableWidth(slides),
        infinite: false,
        touchThreshold: 40,
        ...overrideSettings,
      };

      if (effectiveSettings.vertical) {
        effectiveSettings.variableWidth = false;
        effectiveSettings.slidesToShow = Math.min(
          slideCount,
          effectiveSettings.slidesToShow
        );
      }

      if (slideCount <= 1) {
        effectiveSettings.infinite = false;
        effectiveSettings.centerMode = false;
        effectiveSettings.autoplay = false;
        effectiveSettings.arrows = false;
        effectiveSettings.dots = false;
      }

      return effectiveSettings;
    },
    [autoplaySpeed, overrideSettings, shouldUseVariableWidth]
  );

  return { getSettings };
};

export default useBannerSliderSettings;
